<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/additional-inter-header.png')" class="page__header" />
    <div class="page__container">
      <table class="full-width mt-0">
        <tr class="primary-background">
          <th colspan="2" class="primary-background h1 color-white text-left pl-4 mb-0">
            Serv. Adic. CTT INTERNACIONAL EXPRESS & ECONOMY
          </th>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('SEG_TX_VOL') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('SEG_TX_VOLUNTARIO').value }}% (min
            {{ getAdditionalServiceById('SEG_TX_VOLUNTARIO').minValue
            }}<span class="euro-symbol">€</span>)
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('RWA') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('RWA').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('REMOTE_AREAS_A') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('AREAS_REMOTAS_A').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('REMOTE_AREAS_BC') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('AREAS_REMOTAS').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('REMOTE_AREAS_KG_BC') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('AREAS_REMOTAS_KG').value
            }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('SPC_HAND_EXC_DIM') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('SPC_HAND_EXC_DIM').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('SUPL_DIMENSION') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('DIMENSION').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('SUPL_EMBALAJE') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('EMBALAJE').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('SUPL_PESO') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('PESO').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('DRY_ICE') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('HIELO_SECO').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('DANGER_GOODS_ADG') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('DANGER_GOODS_ADG').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('DANGER_GOODS_IDG') }}
          </td>
          <td class="body-2 text-center">
            {{ getAdditionalServiceById('DANGER_GOODS_IDG').value }}<span class="euro-symbol">€</span>
          </td>
        </tr>
        <tr>
          <td class="body-2">
            {{ $t('DEV_SHIPMENTS') }}
          </td>
          <td class="body-2 text-center">Mismo precio que el envío de salida</td>
        </tr>
      </table>

      <p class="body-2 body-2--bold mb-2 mt-4">
        Otras consideraciones de los Servicios de Internacional:
      </p>
      <ul class="list-style-none body-2">
        <li class="pl-4">
          - CTT Internacional Express: Cobertura por siniestro: Convenio de Varsovia (20€ kg real
          siniestrado).
        </li>
        <li class="pl-4">
          - CTT Internacional Economy: Cobertura por siniestro: CMR (indemnización máxima de 11,97€ por kg
          peso bruto).
        </li>
        <li class="pl-4">
          - La unidad monetaria de esta tarifa es el Euro (<span class="euro-symbol">€</span>). Esta
          tarifa no incluye impuestos tales como el IVA y gastos derivados de la exportación.
        </li>
      </ul>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026/Footer'

export default {
  name: 'AdditionalServicesInternational',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  methods: {
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('AdditionalServicesInternational')
  },
}
</script>
